export default "__VITE_ASSET__BgigcYK1__"